module.exports = __webpack_public_path__ + "img/nav-internet.db803728.svg";